import { ADD, ADD_MULTIPLE, REMOVE, SET_TOTAL } from './constants';

export const addAction = (organizer) => ({
  type: ADD,
  organizer,
});

export const addMultipleAction = (organizers) => ({
  type: ADD_MULTIPLE,
  organizers,
});

export const removeAction = (id) => ({
  type: REMOVE,
  id,
});

export const setTotalAction = (total) => ({
  type: SET_TOTAL,
  total,
});
